var ShapePageTransformModel = require('./shapePageTransformModel');


var ShapeTransformModel = function() {

    this.ox = 0;
    this.oy = 0;
    this.r = 0;
    this.obox = null;

    // only for Hover Shapes -- could extend -- this are computed as 'rotated'
    this.dx = 0;
    this.dy = 0;

    /* Storage of the rotation types for persisting the SVG -- now only in text stamps -- if have more, extend to other objects later */
    /* Non-view implies not from the page transform */
    this.nonViewRotateTransform = '';
    this.nonViewTransform = '';
    this.textYOffsetTransform = '';

    this.pageTransformModel = new ShapePageTransformModel();

    return this;

};



_.extend( ShapeTransformModel.prototype, {

    initializePageValues: function( pageModel, scale ) {
        this.pageTransformModel.initializeValues( pageModel, scale );
        return this;
    },

    setRotation: function( rotation ) {
        this.r = rotation;
    },

    getRotation: function() {
        return this.r;
    },

    getPageModel: function() {
        return this.pageTransformModel;
    },

    getOBox: function() {
        return this.obox;
    },

    setOBox: function( box ) {
        this.obox = box;
    },

    setDx: function( dx ) {
        this.dx = dx;
    },

    getDx: function( ) {
        return this.dx;
    },

    setDy: function( dy ) {
        this.dy = dy;
    },

    getDy: function() {
        return this.dy;
    },

    setOx: function( ox ) {
        this.ox = ox;
    },

    getOx: function() {
        return this.ox;
    },

    setOy: function( oy ) {
        this.oy = oy;
    },

    getOy: function() {
        return this.oy;
    },

    getNonViewRotateTransform: function() {
        return this.nonViewRotateTransform;
    },

    setNonViewRotateTransform: function( transform ) {
        this.nonViewRotateTransform = transform;
    },

    getNonViewTransform: function() {
        return this.nonViewTransform;
    },
    setNonViewTransform: function( transform ) {
        this.nonViewTransform = transform;
    },

    getTextYOffsetTransform: function() {
        return this.textYOffsetTransform;
    },

    setTextYOffsetTransform: function( transform ) {
        this.textYOffsetTransform = transform;
    }

});



module.exports = ShapeTransformModel;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/shapeTransformModel/shapeTransformModel.js
 ** module id = 256
 ** module chunks = 0
 **/